import React from 'react';
import Icon from '../../../components/AppIcon';


const PhoneFrame = ({ children, artistData, currentSection }) => {
  return (
    <div className="relative mx-auto">
      {/* Phone Frame */}
      <div className="relative w-80 h-[680px] bg-gray-900 rounded-[3rem] p-2 shadow-2xl">
        {/* Screen */}
        <div className="w-full h-full bg-white rounded-[2.5rem] overflow-hidden relative">
          {/* Status Bar */}
          <div className="flex justify-between items-center px-6 py-2 bg-black text-white text-xs">
            <span>9:41</span>
            <div className="flex items-center space-x-1">
              <Icon name="Signal" size={12} />
              <Icon name="Wifi" size={12} />
              <Icon name="Battery" size={12} />
            </div>
          </div>
          
          {/* App Content */}
          <div className="h-full bg-white overflow-y-auto">
            {children}
          </div>
        </div>
        
        {/* Home Button */}
        <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-12 h-1 bg-gray-600 rounded-full"></div>
      </div>
      
      {/* Phone Shadow */}
      <div className="absolute inset-0 bg-black opacity-20 rounded-[3rem] transform translate-x-1 translate-y-1 -z-10"></div>
    </div>
  );
};

export default PhoneFrame;